module.exports = __webpack_public_path__ + "static/media/clock.31a4a04a.svg";